"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Observable_1 = require("rxjs/Observable");
var operators_1 = require("rxjs/operators");
var idm_kb_service_client_js_1 = require("@synisys/idm-kb-service-client-js");
var idm_de_core_frontend_1 = require("@synisys/idm-de-core-frontend");
var idm_um_permission_client_js_1 = require("@synisys/idm-um-permission-client-js");
var document_sort_config_1 = require("../model/config/document-sort-config");
var category_filter_criteria_1 = require("../model/view/category-filter-criteria");
var document_meta_data_filter_criteria_1 = require("../model/view/document-meta-data-filter-criteria");
var main_entity_documents_1 = require("../model/view/main-entity-documents");
var document_search_response_1 = require("../model/api/document-search-response");
var related_category_documents_1 = require("../model/view/related-category-documents");
var DocumentSearchHelper = /** @class */ (function () {
    function DocumentSearchHelper() {
    }
    DocumentSearchHelper.getInstanceFieldName = function (kbService, category) {
        return kbService.getMetaFields(category)
            .pipe(operators_1.switchMap(function (metaFields) {
            var metaField = metaFields.find(function (value) { return value.getType() === idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE; });
            if (metaField) {
                return Observable_1.Observable.of(metaField.getSystemName());
            }
            throw new Error("Instance id not exists for category = " + category);
        }), operators_1.publishReplay(1), operators_1.refCount());
    };
    DocumentSearchHelper.getMainEntitiesByInstanceIds = function (portfolioService, mainCategoryInstanceFiledName, mainCategoryInstanceIds, mainCategory) {
        var fb = new idm_de_core_frontend_1.FilterBuilder();
        if (mainCategoryInstanceIds.length) {
            fb.in(mainCategoryInstanceFiledName, mainCategoryInstanceIds);
        }
        return portfolioService.loadEntitySearchItems(mainCategory, [], mainCategoryInstanceFiledName, new idm_de_core_frontend_1.PagingOptions(0, 10000), undefined, fb.buildJson(), [idm_um_permission_client_js_1.CategoryPermissionType.VIEW]).pipe(operators_1.map(function (serviceResponse) { return (serviceResponse.getData() ? serviceResponse.getData() : []); }));
    };
    DocumentSearchHelper.getDocumentSortConfig = function (isDescendingSort, sortDocumentFields) {
        var sortOrder = isDescendingSort ? 'DESC' : 'ASC';
        return new document_sort_config_1.DocumentSortConfig(sortOrder, sortDocumentFields);
    };
    DocumentSearchHelper.constructAdditionalFiltersMap = function (additionalFilterConfigs) {
        var additionalFiltersMap = new Map();
        for (var _i = 0, additionalFilterConfigs_1 = additionalFilterConfigs; _i < additionalFilterConfigs_1.length; _i++) {
            var additionalFilterConfig = additionalFilterConfigs_1[_i];
            additionalFiltersMap.set(additionalFilterConfig.category, new category_filter_criteria_1.CategoryFilterCriteria(additionalFilterConfig.predefinedFilter));
        }
        return additionalFiltersMap;
    };
    DocumentSearchHelper.constructAdditionalDocumentMetaDataFiltersMap = function (additionalFilterConfigs) {
        var additionalDocumentMetaDataFiltersMap = new Map();
        for (var _i = 0, additionalFilterConfigs_2 = additionalFilterConfigs; _i < additionalFilterConfigs_2.length; _i++) {
            var additionalFilterConfig = additionalFilterConfigs_2[_i];
            additionalDocumentMetaDataFiltersMap.set(additionalFilterConfig.key, new document_meta_data_filter_criteria_1.DocumentMetaDataFilterCriteria());
        }
        return additionalDocumentMetaDataFiltersMap;
    };
    DocumentSearchHelper.constructMainCategoryDocuments = function (entitiesDocuments, mainCategory, mainCategoryInstanceFiledName, categoryNameMetaFields, languageId) {
        var mainEntityDocumentsInstanceID = new Map();
        var _loop_1 = function (entityDocuments) {
            if (entityDocuments.category === mainCategory) {
                var instanceId = entityDocuments.entity[mainCategoryInstanceFiledName];
                if (!mainEntityDocumentsInstanceID.has(instanceId)) {
                    var mainEntityDocuments = new main_entity_documents_1.MainEntityDocuments();
                    mainEntityDocuments.mainEntityInstanceId = instanceId;
                    mainEntityDocuments.mainEntityName = Observable_1.Observable.of(categoryNameMetaFields.get(entityDocuments.category)
                        .map(function (metaFieldId) { return DocumentSearchHelper.extractMainEntityName(entityDocuments, metaFieldId, languageId); })
                        .filter(function (value) { return !!value; })
                        .join('/'));
                    mainEntityDocuments.mainEntityDocuments = entityDocuments;
                    mainEntityDocuments.relatedCategoriesDocuments = [];
                    mainEntityDocumentsInstanceID.set(instanceId, mainEntityDocuments);
                }
            }
        };
        for (var _i = 0, entitiesDocuments_1 = entitiesDocuments; _i < entitiesDocuments_1.length; _i++) {
            var entityDocuments = entitiesDocuments_1[_i];
            _loop_1(entityDocuments);
        }
        return mainEntityDocumentsInstanceID;
    };
    DocumentSearchHelper.extractMainEntityName = function (entityDocument, metaFieldId, languageId) {
        var entityName = entityDocument.entity[metaFieldId.getSystemName()];
        if (typeof entityName === 'string') {
            return entityName;
        }
        var multilingualName = entityName;
        return multilingualName && multilingualName[languageId];
    };
    DocumentSearchHelper.constructDocumentsFilter = function (fromDate, toDate, additionalDocumentsFilter) {
        var filter = {
            'bool': {}
        };
        if (fromDate || toDate) {
            var documentsFilter = {
                'range': {
                    'createdDate': {}
                }
            };
            if (fromDate) {
                documentsFilter['range']['createdDate']['gte'] = Number((fromDate.getTime() / 1000).toFixed());
            }
            if (toDate) {
                var oneDay = 1000 * 60 * 60 * 24;
                documentsFilter['range']['createdDate']['lt'] = Number(((toDate.getTime() + oneDay) / 1000).toFixed());
            }
            filter['bool']['must'] = filter['bool']['must'] || [];
            filter['bool']['must'].push(documentsFilter);
        }
        additionalDocumentsFilter.forEach(function (value) {
            if (value.userDefined) {
                filter['bool']['must'] = filter['bool']['must'] || [];
                filter['bool']['must'].push(JSON.parse(value.userDefined));
            }
        });
        return JSON.stringify(filter);
    };
    DocumentSearchHelper.constructFilters = function (additionalFilters) {
        var filters = {};
        additionalFilters
            .forEach(function (value, category) {
            if (value.preDefined || value.userDefined || value.mainCategoryDefined) {
                var fb = new idm_de_core_frontend_1.FilterBuilder();
                // append predefined filter
                if (value.preDefined) {
                    fb.and(value.preDefined);
                }
                // append user defined filter
                if (value.userDefined) {
                    fb.and(value.userDefined);
                }
                // append main category defined filter
                if (value.mainCategoryDefined) {
                    fb.and(value.mainCategoryDefined);
                }
                filters[category] = JSON.stringify(fb.buildJson());
            }
        });
        return filters;
    };
    DocumentSearchHelper.fillMainEntityDefinedFilters = function (entities, additionalFilters, relationConfig) {
        var result = new Map();
        var mainEntityInstanceIds = entities.map(function (value) { return value.id; });
        relationConfig.lookupFields.forEach(function (lookupField, category) {
            result.set(category, new category_filter_criteria_1.CategoryFilterCriteria());
            if (additionalFilters.has(category)) {
                result.get(category).preDefined = additionalFilters.get(category).preDefined;
                result.get(category).userDefined = additionalFilters.get(category).userDefined;
            }
            if (category !== relationConfig.mainCategory) {
                result.get(category).mainCategoryDefined = new idm_de_core_frontend_1.FilterBuilder().in(relationConfig.lookupFields.get(category), mainEntityInstanceIds).build();
            }
        });
        return result;
    };
    DocumentSearchHelper.fillRelatedCategoriesDocuments = function (mainEntityDocumentsMap, entitiesDocuments, entities, categoryRelationConfig, categoryNameMetaFields, languageId) {
        var _loop_2 = function (entityDocuments) {
            if (entityDocuments.category !== categoryRelationConfig.mainCategory) {
                var mainCategoryInstanceId_1 = entityDocuments.entity[categoryRelationConfig.lookupFields.get(entityDocuments.category)];
                if (!mainEntityDocumentsMap.has(mainCategoryInstanceId_1)) {
                    var entitySearchItem_1 = entities.find(function (value) { return value.id === mainCategoryInstanceId_1; });
                    var mainEntityDocuments = new main_entity_documents_1.MainEntityDocuments();
                    mainEntityDocuments.mainEntityInstanceId = mainCategoryInstanceId_1;
                    mainEntityDocuments.mainEntityName = entitySearchItem_1 ?
                        Observable_1.Observable.of(categoryNameMetaFields.get(categoryRelationConfig.mainCategory)
                            .map(function (metaFieldId) { return entitySearchItem_1.entity[metaFieldId.getSystemName()]; })
                            .filter(function (value) { return !!value; })
                            .join('/')) :
                        Observable_1.Observable.of("" + mainCategoryInstanceId_1);
                    mainEntityDocuments.relatedCategoriesDocuments = [];
                    mainEntityDocumentsMap.set(mainCategoryInstanceId_1, mainEntityDocuments);
                }
                entityDocuments.entity['entityName'] = categoryNameMetaFields.get(entityDocuments.category)
                    .map(function (metaFieldId) { return DocumentSearchHelper.extractMainEntityName(entityDocuments, metaFieldId, languageId); }).join(' / ');
                var relatedCategoryDocuments = mainEntityDocumentsMap.get(mainCategoryInstanceId_1)
                    .relatedCategoriesDocuments.find(function (value) { return value.category === entityDocuments.category; });
                if (relatedCategoryDocuments) {
                    relatedCategoryDocuments.entitiesDocuments.push(entityDocuments);
                }
                else {
                    relatedCategoryDocuments = new related_category_documents_1.RelatedCategoryDocuments();
                    relatedCategoryDocuments.category = entityDocuments.category;
                    relatedCategoryDocuments.entitiesDocuments = [entityDocuments];
                    mainEntityDocumentsMap.get(mainCategoryInstanceId_1).relatedCategoriesDocuments.push(relatedCategoryDocuments);
                }
            }
        };
        for (var _i = 0, entitiesDocuments_2 = entitiesDocuments; _i < entitiesDocuments_2.length; _i++) {
            var entityDocuments = entitiesDocuments_2[_i];
            _loop_2(entityDocuments);
        }
    };
    DocumentSearchHelper.constructCategoryNameMetaFields = function (categories) {
        var categoryNameMetaFields = new Map();
        for (var _i = 0, _a = Array.from(categories.values()); _i < _a.length; _i++) {
            var metaCategory = _a[_i];
            categoryNameMetaFields.set(metaCategory.getSystemName(), metaCategory.getNameMetaFieldIds());
        }
        return categoryNameMetaFields;
    };
    DocumentSearchHelper.constructCategoryDisplayName = function (categories) {
        var displayNameMap = new Map();
        for (var _i = 0, _a = Array.from(categories.values()); _i < _a.length; _i++) {
            var metaCategory = _a[_i];
            displayNameMap.set(metaCategory.getSystemName(), metaCategory.getDisplayNameMultilingual());
        }
        return displayNameMap;
    };
    DocumentSearchHelper.constructUsersMap = function (users) {
        var usersMap = new Map();
        for (var _i = 0, users_1 = users; _i < users_1.length; _i++) {
            var user = users_1[_i];
            usersMap.set(user.getId(), user.getName());
        }
        return usersMap;
    };
    DocumentSearchHelper.handleDocumentSearchErrorResponse = function () {
        return Observable_1.Observable.of({ entities: [], entitiesDocuments: new document_search_response_1.DocumentSearchResponse(204, []) });
    };
    DocumentSearchHelper.isLoadedPartial = function (documentSearchResponse) {
        return documentSearchResponse.status === 206;
    };
    DocumentSearchHelper.constructFilterCriteria = function (metaFields, values) {
        var filterBuilder = new idm_de_core_frontend_1.FilterBuilder();
        var containsOption = false;
        for (var _i = 0, metaFields_1 = metaFields; _i < metaFields_1.length; _i++) {
            var metaField = metaFields_1[_i];
            var fieldSystemName = metaField.getSystemName();
            if (values.has(fieldSystemName) && values.get(fieldSystemName)) {
                switch (metaField.getType()) {
                    case idm_kb_service_client_js_1.MetaFieldType.INTEGER_IDENTITY:
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.INTEGER:
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.STRING:
                        if (values.get(fieldSystemName).trim().length) {
                            filterBuilder.and(new idm_de_core_frontend_1.FilterBuilder().contains(fieldSystemName, values.get(fieldSystemName)).build());
                            containsOption = true;
                        }
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING:
                        if (values.get(fieldSystemName).trim().length) {
                            filterBuilder.and(new idm_de_core_frontend_1.FilterBuilder().contains(fieldSystemName, values.get(fieldSystemName)).build());
                            containsOption = true;
                        }
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.DATE:
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.DATE_TIME:
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.BOOLEAN:
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER:
                        filterBuilder.and(new idm_de_core_frontend_1.FilterBuilder().is(fieldSystemName, values.get(fieldSystemName)).build());
                        containsOption = true;
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.PARENT:
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT:
                        if (values.get(fieldSystemName).length) {
                            filterBuilder.and(new idm_de_core_frontend_1.FilterBuilder().in(fieldSystemName, values.get(fieldSystemName)).build());
                            containsOption = true;
                        }
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY:
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY:
                        if (values.get(fieldSystemName).length) {
                            filterBuilder.and(new idm_de_core_frontend_1.FilterBuilder().in(fieldSystemName, values.get(fieldSystemName)).build());
                            containsOption = true;
                        }
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.DECIMAL:
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.BIG_DECIMAL:
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE:
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.DOCUMENT:
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.MULTILINESTRING:
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.WORKFLOW_STATE:
                        if (values.get(fieldSystemName).length) {
                            filterBuilder.and(new idm_de_core_frontend_1.FilterBuilder().in(fieldSystemName, values.get(fieldSystemName)).build());
                            containsOption = true;
                        }
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.USER:
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE:
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE_TIME:
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.MONEY:
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING:
                        break;
                    case idm_kb_service_client_js_1.MetaFieldType.LOOKUP:
                        break;
                }
            }
        }
        return containsOption ? filterBuilder.build() : undefined;
    };
    DocumentSearchHelper.constructClassifiersViewMap = function (data) {
        var classifiersViewMap = new Map();
        data.forEach(function (value) { return classifiersViewMap.set(value.category, value.values); });
        return classifiersViewMap;
    };
    DocumentSearchHelper.constructMetaDataFilterCriteria = function (key, fieldType, values) {
        var containsOption = false;
        var metaDataFilters = {
            'term': {}
        };
        switch (fieldType) {
            case idm_kb_service_client_js_1.MetaFieldType.INTEGER_IDENTITY:
                break;
            case idm_kb_service_client_js_1.MetaFieldType.INTEGER:
                break;
            case idm_kb_service_client_js_1.MetaFieldType.STRING:
                if (values && values.trim() && values.trim().length) {
                    metaDataFilters['term'][key] = values.toLowerCase();
                    containsOption = true;
                }
                break;
            case idm_kb_service_client_js_1.MetaFieldType.MULTILINGUAL_STRING:
                if (values && values.trim() && values.trim().length) {
                    metaDataFilters['term'][key] = values;
                    containsOption = true;
                }
                break;
            case idm_kb_service_client_js_1.MetaFieldType.DATE:
                break;
            case idm_kb_service_client_js_1.MetaFieldType.DATE_TIME:
                break;
            case idm_kb_service_client_js_1.MetaFieldType.BOOLEAN:
                break;
            case idm_kb_service_client_js_1.MetaFieldType.CLASSIFIER:
                metaDataFilters['term'][key] = values;
                containsOption = true;
                break;
            case idm_kb_service_client_js_1.MetaFieldType.PARENT:
                break;
            case idm_kb_service_client_js_1.MetaFieldType.MULTI_SELECT:
                if (values && values.length) {
                    metaDataFilters['term'][key] = values;
                    containsOption = true;
                }
                break;
            case idm_kb_service_client_js_1.MetaFieldType.SUB_ENTITY:
                break;
            case idm_kb_service_client_js_1.MetaFieldType.MAIN_ENTITY:
                break;
            case idm_kb_service_client_js_1.MetaFieldType.DECIMAL:
                break;
            case idm_kb_service_client_js_1.MetaFieldType.BIG_DECIMAL:
                break;
            case idm_kb_service_client_js_1.MetaFieldType.INTEGER_INSTANCE:
                break;
            case idm_kb_service_client_js_1.MetaFieldType.DOCUMENT:
                break;
            case idm_kb_service_client_js_1.MetaFieldType.MULTILINESTRING:
                break;
            case idm_kb_service_client_js_1.MetaFieldType.USER:
                break;
            case idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE:
                break;
            case idm_kb_service_client_js_1.MetaFieldType.LOCAL_DATE_TIME:
                break;
            case idm_kb_service_client_js_1.MetaFieldType.MONEY:
                break;
            case idm_kb_service_client_js_1.MetaFieldType.ACCOUNTING:
                break;
            case idm_kb_service_client_js_1.MetaFieldType.LOOKUP:
                break;
        }
        return containsOption ? JSON.stringify(metaDataFilters) : undefined;
    };
    return DocumentSearchHelper;
}());
exports.DocumentSearchHelper = DocumentSearchHelper;
//# sourceMappingURL=document-search-helper.js.map